module.exports = __webpack_public_path__ + "img/closed-case.8f7df2d2.svg";